import { BUBBLE_MAX_RADIUS, BUBBLE_MIN_RADIUS } from "./constants";

// Anchos de referencia (px) entre los que se interpola el radio de las burbujas
const RADIUS_BREAKPOINT_SMALL = 380; // Celulares chicos: se usa _BUBBLE_MIN_RADIUS
const RADIUS_BREAKPOINT_LARGE = 900; // Tablets/desktop: se usa _BUBBLE_MAX_RADIUS

/**
 * Calcula el radio de burbuja adecuado según el ancho disponible (contenedor o viewport),
 * interpolando linealmente entre _BUBBLE_MIN_RADIUS y _BUBBLE_MAX_RADIUS.
 * Esto permite achicar las burbujas en pantallas pequeñas en lugar de usar un tamaño fijo.
 */
export function computeBubbleRadius(width: number): number {
    if (!width || width <= RADIUS_BREAKPOINT_SMALL) return BUBBLE_MIN_RADIUS;
    if (width >= RADIUS_BREAKPOINT_LARGE) return BUBBLE_MAX_RADIUS;

    const t = (width - RADIUS_BREAKPOINT_SMALL) / (RADIUS_BREAKPOINT_LARGE - RADIUS_BREAKPOINT_SMALL);
    return Math.round(BUBBLE_MIN_RADIUS + t * (BUBBLE_MAX_RADIUS - BUBBLE_MIN_RADIUS));
}